document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".best-seller-section-wrapper");

  sections.forEach((section) => {
    const track = section.querySelector(".best-seller-carousel-track");
    const prevBtn = section.querySelector(".prev-btn");
    const nextBtn = section.querySelector(".next-btn");

    if (!track || !prevBtn || !nextBtn) return;

    function updateNavButtons() {
      prevBtn.disabled = track.scrollLeft <= 5;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    }

    nextBtn.addEventListener("click", () => {
      const cardWidth = track.querySelector(".product-card-item").offsetWidth + 20;
      track.scrollBy({ left: cardWidth, behavior: "smooth" });
    });

    prevBtn.addEventListener("click", () => {
      const cardWidth = track.querySelector(".product-card-item").offsetWidth + 20;
      track.scrollBy({ left: -cardWidth, behavior: "smooth" });
    });

    track.addEventListener("scroll", updateNavButtons);
    window.addEventListener("resize", updateNavButtons);
    
    // Run initialization once images render layout size dimensions
    setTimeout(updateNavButtons, 500);
  });
});